import { useMutation } from 'react-query';
import { UserAPI } from 'api/user';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdatePassword() {
  return useMutation(
    UserAPI.updatePassword,
    {
      onSuccess: ({ message }) => {
        dispatchToast({ message, type: 'success' })
      },
    }
  );
}
